import { render, staticRenderFns } from "./DraggableWrapper.vue?vue&type=template&id=3e989743&"
import script from "./DraggableWrapper.vue?vue&type=script&lang=js&"
export * from "./DraggableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports